<template>
<div class="chapter">
<div class="inner_page">
<p class="noindentd"><a id="page_6"><span class="txit">All the incidents in this story are real. They did not happen in just the order they are recorded, but they all happened at one time or another on the little island of Chincoteague.</span></a></p><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?4c1fa64d